import { useSelector } from 'react-redux';

type UsePipelinesRepository = {
  pipelines: any;
};

function usePipelinesRepository(): UsePipelinesRepository {
  const pipelines = useSelector((s: any) => s.pipelines);

  return {
    pipelines,
  };
}

export { usePipelinesRepository };
